<script>
/* eslint-disable vue/no-reserved-keys */
/* eslint-disable eqeqeq */
import _ from "lodash";
import DeviceDetector from "device-detector-js";

export default {
    data() {
        return {
            _: _,
        };
    },
    computed: {
        $device() {
            const deviceDetector = new DeviceDetector();
            const detector = deviceDetector.parse(window.navigator.userAgent);

            return {
                isMobile: detector.device.type == "smartphone",
                isTablet: detector.device.type == "tablet",
                isDesktop: detector.device.type == "desktop",
            };
        },
    },
};
</script>